import axios from 'axios';
import authHeader from "@/service/auth-header";

class ProviderComponentService {

    async searchProviderComponentsByDescription(description) {
        console.log("[ProviderComponentService][searchProviderComponentsByDescription] Before making Rest call. " +
            "description = ", description);

        return axios.get('/api/providercomponent/search/description', {
            params: { q: description },
            headers: authHeader()
        });
    }

}

export default new ProviderComponentService();
